<template>
    <div class="ServiceLayout">
        <router-view />
    </div>
</template>
